var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3307 26.1969V36.3998C34.3307 36.7359 34.0741 37 33.7474 37H16.2474C15.9207 37 15.6641 36.7359 15.6641 36.3998V26.1969C15.6641 25.9208 15.8507 25.6808 16.1074 25.6207L18.4407 25.0206C18.6157 24.9726 18.8024 25.0086 18.9424 25.1286C19.0824 25.2366 19.1641 25.4167 19.1641 25.5967V30.3981C19.1641 30.7342 19.4207 30.9983 19.7474 30.9983H30.2474C30.5741 30.9983 30.8307 30.7342 30.8307 30.3981V25.5967C30.8307 25.4167 30.9124 25.2366 31.0524 25.1286C31.1924 25.0206 31.3791 24.9726 31.5541 25.0206L33.8874 25.6207C34.1441 25.6808 34.3307 25.9208 34.3307 26.1969Z",
    fill: "#EA873C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7633 20.5881L34.5559 14.9279C34.0986 13.7539 33.0138 13 31.7895 13H18.2112C16.9869 13 15.8998 13.7539 15.4425 14.9279L13.2248 20.5881C12.9733 21.2554 12.9288 21.9475 13.1117 22.5407C13.5689 24.0113 14.8938 25 16.3913 25C17.5916 25 18.6433 24.3697 19.2606 23.4181C19.8779 24.3697 20.9308 25 22.1311 25C23.3314 25 24.3819 24.3697 24.9992 23.4181C25.6165 24.3697 26.6682 25 27.8696 25C29.0699 25 30.1216 24.3574 30.7389 23.4058C31.3574 24.3574 32.4182 25 33.6071 25C35.1057 25 36.4318 24.0113 36.889 22.5407C37.0731 21.9475 37.0262 21.2554 36.7633 20.5881Z",
    fill: "#EA873C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainicon);
export default __webpack_public_path__ + "static/media/mainicon.f3715f89b1e28a553fc778d599ae8acf.svg";
export { ForwardRef as ReactComponent };